import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import viVN from 'antd/locale/vi_VN';
import Login from './components/Login';
import Home from './components/Home';
import GiaoViecComponent from './components/GiaoViecComponent';
import ViecDangLamComponent from './components/ViecDangLamComponent';
import JobHistoryComponent from './components/JobHistoryComponent';
import DiemDanhComponent from './components/DiemDanhComponent';
import ResetStatusComponent from './components/ResetStatusComponent';
import { setNavigate } from './utils/axiosCustomize';
import 'antd/dist/reset.css';

const theme = {
  token: {
    colorPrimary: '#0D9488',
    colorLink: '#0D9488',
    borderRadius: 8,
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
  },
  components: {
    Layout: {
      headerBg: '#ffffff',
      siderBg: '#ffffff',
      bodyBg: '#f5f7fa',
    },
    Card: {
      borderRadiusLG: 12,
    },
    Menu: {
      itemSelectedBg: '#F0FDFA',
      itemSelectedColor: '#0D9488',
      itemHoverColor: '#0D9488',
      itemBorderRadius: 8,
      itemHeight: 44,
    },
    Table: {
      headerBg: '#0D9488',
      headerColor: '#ffffff',
      headerSplitColor: 'rgba(255,255,255,0.18)',
      headerBorderRadius: 8,
      borderRadiusLG: 8,
      rowHoverBg: '#F0FDFA',
      colorBgContainer: '#ffffff',
    },
    Button: {
      borderRadius: 8,
    },
  },
};

// Component để thiết lập navigate cho axios
const NavigationSetup = () => {
  const navigate = useNavigate();

  useEffect(() => {
    setNavigate(navigate);
  }, [navigate]);

  return null;
};

// Component để bảo vệ route
const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('accessToken');
  return token ? children : <Navigate to="/login" replace />;
};

function App() {
  return (
    <ConfigProvider locale={viVN} theme={theme}>
      <Router>
        <NavigationSetup />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/home"
            element={
              <ProtectedRoute>
                <Home />
              </ProtectedRoute>
            }
          >
            <Route index element={<Navigate to="giao-viec" replace />} />
            <Route path="giao-viec" element={<GiaoViecComponent />} />
            <Route path="viec-dang-lam" element={<ViecDangLamComponent />} />
            <Route path="lich-su-doi" element={<JobHistoryComponent />} />
            <Route path="thanh-vien-diem-danh" element={<DiemDanhComponent />} />
            <Route path="reset-status" element={<ResetStatusComponent />} />
            <Route path="*" element={<Navigate to="giao-viec" replace />} />
          </Route>
          <Route path="/" element={<Navigate to="/login" replace />} />
        </Routes>
      </Router>
    </ConfigProvider>
  );
}

export default App;
